import Delegate from "//feed-playground-fr.myshopify.com/cdn/shop/t/2/assets/ftdomdelegate.min.js?v=85864865866317895671655307280";

export class ProductCrossSellRecently extends HTMLElement {
  connectedCallback() {

    this.allTabs            = this.querySelectorAll('[data-action="change-tab"]');
    this.allProductsTabs    = this.querySelectorAll('[data-action="products-tab"]');

    this.bestProduct        = this.querySelector('[data-element="add-best-product"]');
    this.productAddedRecently = this.querySelector('[data-element="add-product-recently-viewed"]');

    this.productHandleList  = [];

    this._attachListeners();

    this._loadProductBestSelling();
    this._saveCurrentProduct();
  }

    _attachListeners() {
      new Delegate(this).on('click', '[data-action="change-tab"]', this._changeTab.bind(this));
    }

    _changeTab(event, target) {
      event.preventDefault();

      if (this.allTabs && this.allProductsTabs) {
          for (let i = 0; i < this.allTabs.length; i++) {
          this.allTabs[i].classList.remove('active');
          this.allProductsTabs[i].classList.remove('active');
          }
      }

      target.classList.add('active');
      if (this.querySelector('[data-action="products-tab"][data-tab="'+target.getAttribute('data-tab')+'"]')) {
        this.querySelector('[data-action="products-tab"][data-tab="'+target.getAttribute('data-tab')+'"]').classList.add('active');

        let scrollTab = this.querySelector('.product-cross-sell-recently__tabs-container');
        scrollTab.scrollTo({
          top: 0,
          left: this.querySelector('[data-action="change-tab"][data-tab="'+target.getAttribute('data-tab')+'"]').offsetLeft,
          behavior: "smooth"
        });
      }
    }

    _loadProductBestSelling() {
      if (this.bestProduct) {
        let collection   = this.bestProduct.getAttribute('data-cat');
        let currentID    = this.bestProduct.getAttribute('data-current');

        if (currentID && collection) {
          let url = window.location.origin + '/collections/' + collection + '?view=cross-sell-recently&sort_by=best-selling&id=' + currentID ;

          fetch(url)
          .then((response) => response.text())
          .then((relatedHTML) => {
              this.bestProduct.innerHTML = relatedHTML;
          })
        }
      }
    }

    /**
   * Save current product to localStorage
   */
  _saveCurrentProduct() {

    let that = this;
    let productHandle = this.productAddedRecently.getAttribute('data-current');
    // get localStorage products handles
    let items = JSON.parse(localStorage.getItem('feed-recently-viewed') || '[]');

    // check if product is already in array
    if (productHandle && items.indexOf(productHandle) === -1) {
      items.unshift(productHandle);
    }

    // limit array to 4 products
    items = items.slice(0, 4);

    // set products handles to localStorage
    localStorage.setItem('feed-recently-viewed', JSON.stringify(items));

    // set the query string for the fetch call with products handles
    items.forEach(function (item) {
      that.productHandleList.push(item);
    });

    // check if products are found
    if (items.length > 0) {
      this._recentsProducts();
    }

  }

   async _recentsProducts() {
    let that = this;

     this.productHandleList.forEach(function (productHandle) {
      
      let url = window.location.origin + '/products/' + productHandle + '?view=recently-viewed-products';

      if (that.productAddedRecently) {
        fetch(url)
        .then((response) => response.text())
        .then((html) => {
          that.productAddedRecently.insertAdjacentHTML('beforeend', html);
        })
      }
      
    });

  }

}

try {
  window.customElements.define('product-cross-sell-recently', ProductCrossSellRecently);
} catch(e) {}